import { Button, Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface FormListAddButtonProps {
  fieldsLength: number;
  maxLimit: number;
  add: () => void;
  buttonLabel: string;
}

const FormListAddButton = ({
  fieldsLength,
  maxLimit,
  add,
  buttonLabel,
}: FormListAddButtonProps) => {
  const { t } = useTranslation();

  return (
    <>
      {fieldsLength < maxLimit && (
        <Form.Item>
          <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
            {t("button.add_condition")}
          </Button>
        </Form.Item>
      )}
      {fieldsLength >= maxLimit && (
        <div style={{ color: "#faad14", marginBottom: 24 }}>
          {t("message.info.max_conditions_reached", { max: maxLimit })}
        </div>
      )}
    </>
  );
};

export default FormListAddButton;
